/**
 * Нормализация authorities из API (строки или { name } / { authority }).
 */
export function accountAuthorityNames(account: { authorities?: unknown } | null | undefined): string[] {
  const raw = account?.authorities;
  if (!Array.isArray(raw)) return [];
  const out: string[] = [];
  for (const x of raw) {
    if (typeof x === 'string' && x) {
      out.push(x);
      continue;
    }
    if (x && typeof x === 'object') {
      const o = x as Record<string, unknown>;
      if (typeof o.name === 'string' && o.name) {
        out.push(o.name);
        continue;
      }
      if (typeof o.authority === 'string' && o.authority) {
        out.push(o.authority);
      }
    }
  }
  return out;
}

/** Совпадает с веткой «полный доступ» в liga-api ProgramResource.getPrograms */
export function accountHasFullReleaseCatalogAccess(names: string[]): boolean {
  return (
    names.includes('ROLE_ADMIN') ||
    names.includes('ROLE_MANAGER') ||
    names.includes('ROLE_RELEASE_FULL')
  );
}

export function releaseEffectiveHasAccess(
  release: { hasAccess?: boolean },
  account: { authorities?: unknown } | null | undefined
): boolean {
  if (release.hasAccess === true) return true;
  return accountHasFullReleaseCatalogAccess(accountAuthorityNames(account));
}
